import axios from "axios";

const resolveBackendUrl = () => {
  const envUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
  if (typeof window !== "undefined") {
    const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    if (!isLocal && (envUrl.includes("localhost") || envUrl.includes("127.0.0.1"))) {
      if (/^(\d{1,3}\.){3}\d{1,3}$/.test(window.location.hostname)) {
        return envUrl.replace(/localhost|127\.0\.0\.1/, window.location.hostname);
      }
      return "";
    }
  }
  return envUrl;
};
export const BASE_URL = resolveBackendUrl();
const API = `${BASE_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("okfbi_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
// On any 401 from a state-changing request, force a re-login by redirecting
// to /login (except when we're already there or on /overlay).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const method = (err?.config?.method || "").toLowerCase();
    if (status === 401 && ["post", "put", "patch", "delete"].includes(method)) {
      const p = typeof window !== "undefined" ? window.location.pathname : "";
      // Only force-redirect when on a route that REQUIRES auth (i.e. inside /app or /host).
      // Public surfaces (/, /login, /overlay, /terms, /privacy, /about, /how-to-play,
      // /case-preview, /ranks, /premium-ids, /leaderboard-public, /plans-public, /faq)
      // must never bounce. Uses `startsWith(path + "/")` boundary so public
      // routes with a shared prefix (e.g. /leaderboard-public) are excluded.
      const has = (base) => p === base || p.startsWith(base + "/");
      const isProtected = has("/app") || has("/host") || has("/ops")
        || has("/cases") || has("/case") || has("/suspects")
        || has("/evidence") || has("/forensics") || has("/timeline")
        || has("/notes") || has("/leaderboard") || has("/plans")
        || has("/profile") || has("/credits") || has("/settings");
      if (isProtected) {
        try { window.location.href = "/login"; } catch {}
      }
    }
    return Promise.reject(err);
  }
);
export function formatErr(d) {
  if (d == null) return "حدث خطأ. حاول لاحقاً.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}
export default api;
